module.exports = __webpack_public_path__ + "img/login-bg.31a23871.jpg";